// extracted by mini-css-extract-plugin
module.exports = {"scroller":"OverlayScroller-scroller-20qI4","thumb":"OverlayScroller-thumb-1Lhfi"};